import React, { useState } from 'react';
import './App.css';
import PDFViewer from './components/PDFViewer';

function App() {
  const [selectedPdf, setSelectedPdf] = useState<string>('/pdfs/L0801472.pdf');

  const pdfFiles = [
    { name: 'L0801472文档', path: '/pdfs/L0801472.pdf' },
    { name: '示例文档', path: '/pdfs/sample.pdf' },
    { name: '测试文档1', path: '/pdfs/test1.pdf' },
    { name: '测试文档2', path: '/pdfs/test2.pdf' },
  ];

  return (
    <div className="App">
      <header className="App-header">
        <h1>PDF在线阅读器</h1>
        <p>选择要阅读的PDF文档</p>
      </header>
      
      <main className="App-main">
        <div className="pdf-selector">
          <div className="pdf-list">
            <h2>可用的PDF文档</h2>
            <div className="pdf-grid">
              {pdfFiles.map((pdf, index) => (
                <div 
                  key={index}
                  className={`pdf-item ${selectedPdf === pdf.path ? 'selected' : ''}`}
                  onClick={() => setSelectedPdf(pdf.path)}
                >
                  <div className="pdf-icon">📄</div>
                  <div className="pdf-name">{pdf.name}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div className="viewer-section">
          <PDFViewer url={selectedPdf} />
        </div>
      </main>
    </div>
  );
}

export default App;
